import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, isSubmitting }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[2000]"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-[2001] flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-modal w-full max-w-md">
          <div className="p-6">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full mx-auto mb-4">
              <Icon name="Send" size={24} color="var(--color-primary)" />
            </div>

            <h3 className="text-lg font-semibold text-foreground text-center mb-2">
              Submit Application?
            </h3>
            <p className="text-sm text-muted-foreground text-center mb-6">
              Are you sure you want to submit your application? You won't be able to edit it after submission.
            </p>

            <div className="flex items-center gap-3">
              <Button
                variant="outline"
                fullWidth
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                variant="default"
                fullWidth
                onClick={onConfirm}
                loading={isSubmitting}
                iconName="Send"
                iconPosition="left"
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;